import CalendarMonth from "@mui/icons-material/CalendarMonth";
import type { FC } from "react";
import { ScheduleButton, type ScheduleButtonProps } from "./schedule-button";

export const ScheduleSpecificButton: FC<Omit<ScheduleButtonProps, "icon" | "title">> = (props) => {
  return <ScheduleButton icon={<CalendarMonth />} title="Schedule send" {...props} />;
};
